var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7243_39881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 8.90666H14.4361C14.7044 8.62569 14.8695 8.2453 14.8695 7.8261C14.8695 6.96168 14.1688 6.26089 13.3043 6.26089C12.7597 6.26089 12.2803 6.53915 12 6.96107C11.7196 6.53915 11.2402 6.26089 10.6956 6.26089C9.83122 6.26089 9.13044 6.96168 9.13044 7.8261C9.13044 8.2453 9.29558 8.62574 9.56389 8.90666H5.21741C5.21741 10.0593 6.22133 10.9936 7.37385 10.9936H7.30428C7.30428 12.1462 8.23864 13.0806 9.3913 13.0806C9.3913 13.4539 9.48969 13.8039 9.66144 14.1069L7.93034 15.838L9.2585 17.1661L11.1425 15.2821C11.2163 15.3092 11.2926 15.3309 11.3715 15.3456L10.233 17.916L12 19.8261L13.7669 17.9159L12.6285 15.3456C12.7074 15.3308 12.7837 15.3091 12.8575 15.282L14.7415 17.166L16.0696 15.8379L14.3385 14.1067C14.5103 13.8038 14.6087 13.4538 14.6087 13.0805C15.7613 13.0805 16.6956 12.1461 16.6956 10.9934H16.6261C17.7786 10.9935 18.7826 10.0593 18.7826 8.90666Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7243_39881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/al.0ce459d684cba76e76c25847f8186576.svg";
export { ForwardRef as ReactComponent };